export const INITIAL_STATE = {
  selectedBusinessManagerService: 'store_profile',
};
